import React, {useState, useEffect} from 'react'
import { Button} from '../../components/StyledComponents'
import { Page } from '../../components/ui/Page'
import { Title } from '../../components/layout/Title';
import { Body } from '../../components/layout/Body';

import Store from '../../store/Store'

export default function Return() {
	const [status, setStatus] = useState(null)

	useEffect(() => {
		const hashString = window.location.hash.substring(2) // Remove '#/'
		// Split at 'return?' to remove the route part
		const queryString = hashString.split('return?')[1]
		const urlParams = new URLSearchParams(queryString)

		console.log('Query string:', queryString)
		console.log('URL Params:', urlParams)
		console.log('All params:', Array.from(urlParams.entries()))
		console.log('Session ID:', urlParams.get('session_id'))

		const sessionId = urlParams.get('session_id')

		if (!sessionId) {
			console.log('Session ID is null or empty')
			return
		}

		Store.fetch('consumer/checkout?session_id=' + sessionId)
			.then(data => {
				setStatus(data.status)
			})
			.catch(error => {
				console.error('Error fetching session status:', error)
			})
	}, [])

	if (status === 'open') {
		return <div>OPEN</div>
	}

	if (status === 'complete') {
		return (
			<Page>
				<Body center>
					<>
						<Title>Buchung erfolgreich!</Title>
						<h3>
							Herzlichen Glückwunsch, Sie sind fertig. Den Status
							Ihres Auftrages können Sie im Abschnitt „Aufträge“
							sehen.
						</h3>
						<h4>
							{
								'Bitte beachten Sie, dass Ihr geplanter Drohnenflug am aufgrund der Wetterbedingungen verschoben werden kann. Wir werden Sie über alle Änderungen auf dem Laufenden halten..'
							}
						</h4>

						<Button
							data-pw="button-return-success"
							primary
							onClick={() => Store.navigate('dashboard')}>
							Fertig
						</Button>
					</>
				</Body>
			</Page>
		)
	}

	return <p>Error</p>
}
